import React from "react";
import { PageShell } from "./PageShell";
import { PageIntro } from "../components/PageIntro";
import { News } from "../components/sections/News";

export default function NewsPage() {
  return (
    <PageShell>
      <div className="pt-[72px]">
        <PageIntro contentKey="news" />
        <News hideIntro />
      </div>
    </PageShell>
  );
}
